import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import styles from './AppShell.module.css';

/** The frame every signed-in screen sits in: the bar, its links, and who is signed in. */
export function AppShell({ children }: { children: ReactNode }): ReactNode {
  const { admin, signOut } = useAuth();

  return (
    <div className={styles.shell}>
      <header className={styles.bar}>
        <span className={styles.brand}>Camp Enquetes</span>
        <nav className={styles.nav}>
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.linkActive}` : styles.link)}
          >
            Enquetes
          </NavLink>
          <NavLink
            to="/categorias"
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.linkActive}` : styles.link)}
          >
            Categorias
          </NavLink>
          <NavLink
            to="/imagens"
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.linkActive}` : styles.link)}
          >
            Imagens
          </NavLink>
          <NavLink
            to="/conformidade"
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.linkActive}` : styles.link)}
          >
            Conformidade
          </NavLink>
          <NavLink
            to="/whatsapp"
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.linkActive}` : styles.link)}
          >
            WhatsApp
          </NavLink>
        </nav>
        <span className={styles.who}>{admin?.name ?? admin?.email}</span>
        <button type="button" className={styles.signOut} onClick={signOut}>
          Sair
        </button>
      </header>
      <main className={styles.content}>
        {children}
      </main>
    </div>
  );
}
